import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSun = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-sun",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 4
		}),
		/* @__PURE__ */ _jsx("path", { d: "M12 2v2" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 20v2" }),
		/* @__PURE__ */ _jsx("path", { d: "m4.93 4.93 1.41 1.41" }),
		/* @__PURE__ */ _jsx("path", { d: "m17.66 17.66 1.41 1.41" }),
		/* @__PURE__ */ _jsx("path", { d: "M2 12h2" }),
		/* @__PURE__ */ _jsx("path", { d: "M20 12h2" }),
		/* @__PURE__ */ _jsx("path", { d: "m6.34 17.66-1.41 1.41" }),
		/* @__PURE__ */ _jsx("path", { d: "m19.07 4.93-1.41 1.41" })
	]
});
export default SvgSun;
